module.exports = __webpack_public_path__ + "img/1.86695032.png";